import React, { PureComponent } from 'react';
import { injectIntl, defineMessages } from 'react-intl';

import { Message, List } from 'semantic-ui-react';
import { ModalTemplate, Loading, Button as Btn } from 'components';

import * as common from 'libs/commonFunc';

import classNames from 'classnames/bind';
import styles from './AdminUserDelete.css';
const cx = classNames.bind(styles);

class AdminUserDelete extends PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { deleting, userInfo, removeUser, handleOnToggleDeleteModal } = this.props;
    const { userNo, userName, regEpoch } = userInfo;

    return (
      <ModalTemplate
        closeOnEscape={false}
        closeOnDimmerClick={false}
        className={cx('modal-admin tiny', 'common-content')}
        closeIcon
        onToggleModal={handleOnToggleDeleteModal}
        visible
        header={<div>{defineMessages(formatMessage({ id: 'AdminUserDelete_1', defaultMessage: '사용자 삭제' }))}</div>}
        buttons={
          <div className={cx('inline-block')}>
            <Btn buttonColor="#bbbbbb" onClick={handleOnToggleDeleteModal}>
              {defineMessages(formatMessage({ id: 'AdminUserDelete_2', defaultMessage: '취소' }))}
            </Btn>
            <Btn className={cx('gray-button')} loading={deleting} disabled={deleting} onClick={removeUser}>
              {defineMessages(formatMessage({ id: 'AdminUserDelete_3', defaultMessage: '삭제' }))}
            </Btn>
          </div>
        }>
        <Loading
          active={deleting}
          size="small"
          content={defineMessages(formatMessage({ id: 'AdminUserDelete_4', defaultMessage: '삭제중...' }))}
        />
        <div className={cx('message-header')}>
          {defineMessages(
            formatMessage({
              id: 'AdminUserDelete_5',
              defaultMessage: '등록된 가입자 삭제입니다. 정말로 다음 사용자를 삭제합니까?'
            })
          )}
        </div>
        <Message className={cx('template-detail-box')}>
          <div className={cx('template-detail')}>
            <List bulleted className={cx('template-detail-list')}>
              <List.Item className={cx('template-detail-item')}>
                <div className={cx('template-detail-item-title')}>No</div>
                {userNo}
              </List.Item>
              <List.Item className={cx('template-detail-item')}>
                <div className={cx('template-detail-item-title')}>
                  {defineMessages(formatMessage({ id: 'AdminUserDelete_6', defaultMessage: '사용자명' }))}
                </div>
                {userName}
              </List.Item>
              <List.Item className={cx('template-detail-item')}>
                <div className={cx('template-detail-item-title')}>
                  {defineMessages(formatMessage({ id: 'AdminUserDelete_7', defaultMessage: '등록일시' }))}
                </div>
                {common.timeFormatFromUTCEpoch(regEpoch)}
              </List.Item>
            </List>
          </div>
        </Message>
      </ModalTemplate>
    );
  }
}

export default injectIntl(AdminUserDelete);



// WEBPACK FOOTER //
// ./src/script/components/admin/user/AdminUserDelete.js